var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7168 16.3628V9H47.0442L45.3451 11.8319L47.0442 14.6637H35.7168V16.3628ZM35.7168 16.3628L54.9734 31.0885M35.7168 16.3628L26.0885 23.7257H12.3628L6.13274 37.3186V53.7434M54.9734 31.0885H16.4602V35.6195H18.1593V56.5752H23.2566V44.9823C23.2566 43.8777 24.1521 42.9823 25.2566 42.9823H26.9204C28.0249 42.9823 28.9204 43.8777 28.9204 44.9823V56.5752H34.0177V44.9823C34.0177 43.8777 34.9131 42.9823 36.0177 42.9823H37.115C38.2196 42.9823 39.115 43.8777 39.115 44.9823V56.5752H43.646V44.9823C43.646 43.8777 44.5414 42.9823 45.646 42.9823H46.7434C47.8479 42.9823 48.7434 43.8777 48.7434 44.9823V56.5752H53.2743V35.6195H54.9734V31.0885ZM54.9734 31.0885L45.3451 23.7257H60.0708L66.3009 37.3186V56.5752L68 62.2389H4L5.69912 56.5752H62.9027",
    stroke: "url(#paint0_linear_11408_354213)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11408_354213",
    x1: 4,
    y1: 8.38552,
    x2: 69.1761,
    y2: 60.3056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D9941"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/school.dd06684744be5d6cb32a68ec4c79254e.svg";
export { ForwardRef as ReactComponent };